const mainHeader = document.getElementsByClassName('main-header')[0];
import { ISDESKTOP } from '../constants/commonConstants';

if (typeof mainHeader !== 'undefined' && ISDESKTOP) {
    const headerOffset = 48 + 88 + 82; // meta header + nav header
    const collapseTarget = document.querySelector(".trigger-header-collapse");
    const collapseValue = collapseTarget !== null ? (collapseTarget.getBoundingClientRect().top - headerOffset) : 100;

    window.addEventListener('scroll', () => {
        let scrollPosY = window.pageYOffset | document.body.scrollTop;

        if (scrollPosY > collapseValue) {
            mainHeader.classList.add('is-stuck');
            return;
        }

        mainHeader.classList.remove('is-stuck');
    });
}
